export const ErrorMessages = {
  NULL_ARGUMENTS_NOT_ALLOWED: 'Null arguments not allowed',
  INPUT_VALIDATION_ERROR: 'Input validation Error: ',
  INVALID_INPUT: 'Invalid Input - ',
  ALREADY_EXISTS: {
    A_POST_WITH_THAT_TITLE: 'A post with that title already exists.',
    A_USER_WITH_THAT_EMAIL: 'A user with the email you entered already exists.',
  },
  // errors related to posting a story, post or response to a post
  AN_ERROR_OCCURRED: {
    WHILE_DELETING_THE_POST: 'An error occurred while deleting the post: ',
    WHILE_UPDATING_THE_POST: 'An error occurred while updating the post.',
    WHILE_UPDATING_THE_USER: 'An error occurred while updating the user.',
    WHILE_READING_THE_USER_PREFERENCES:
      'An error occurred while getting the user preferences.',
    WHILE_UPDATING_THE_USER_PREFERENCES:
      'An error occurred while updating the user preferences.',
  },
  NOT_FOUND: {
    NO_USER: 'User not found',
    NO_POST: 'Post not found',
    NO_POSTS: 'No Old Posts have been found for this user.',
    NO_FEED: 'User with this user id has no feed',
    NO_USERNAME: 'Username not found.',
    NO_USER_ID: 'User ID not found',
  },
  NOT_CREATED: {
    NO_POSTS_YET: 'You have not created your first post yet.',
  },
  FAILED: {
    TO_RETRIEVE_USER_POSTS: 'Failed to retrieve user posts',
    TO_RETRIEVE_USER_POST: 'Failed to retrieve this post',
    TO_GET_USER: 'Failed to get user data',
  },
  UNSUPPORTED: {
    VIDEO_TAG: 'Your browser does not support the video tag...',
  },
  UNEXPECTED: {
    DB_ERROR: 'Unexpected database error',
  },
  PRE_SIGNED_URL_ERRORS: {
    DEFAULT: 'Method Not Allowed',
    FILE_TOO_LARGE: 'File size exceeds 3MB limit',
    SELECT_FILE: 'Please select a file first',
    INVALID_KEY: 'Key parameter is required',
    ERROR: 'Error generating pre-signed URL',
    FAILED_TO_GET_PRESIGNED_URL: 'Failed to get presigned URL',
    FAILED_TO_UPLOAD: 'Error uploading file',
    FAILED_TO_DOWNLOAD: 'Failed to download avatar',
    ENV_VARS_NOT_SET:
      'Environment variables BUCKET NAME and/or AWS REGION are not set',
    INVALID_FILE_TYPE:
      'Invalid file type. Only .jpg, .jpeg and .png files are allowed.',
  },
  AVATAR: {
    UPDATE_FAILED: 'Failed updating the avatar.',
  },
  FEED: {
    REFRESHING: 'Error refreshing feed',
    LOADING: 'Error loading more posts',
    PREVIEW: 'No preview available',
  },
  STORY_ANALYTICS: {
    REQUIRES_REVISION: 'Requires Revision',
  },
};

export default ErrorMessages;
